<template>
  <div>
    <NavBar />
    <div class="content-container">
      <div class="list-container">
        <div style="margin-bottom: 16px;">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-tab-pane
              label="待申请结算列表"
              name="first"
            >
              <Confirm v-if="isFirst" />
            </el-tab-pane>
            <el-tab-pane
              label="账单列表"
              name="second"
            >
              <Confirmed v-if="isSecond" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/navBar";
import Setting from "@/settings.js";
var { pageConfig } = Setting;

import Confirm from "./components/confirm";
import Confirmed from "./components/confirmed";
export default {
  components: {
    NavBar,
    Confirm,
    Confirmed,
  },
  data () {
    return {
      activeName: "first",
      isFirst: true,
      isSecond: false,
    };
  },
  mounted () { },
  methods: {
    //点击切换监听
    handleClick (tab, event) {
      if (tab.name === "first") {
        this.isFirst = true;
        this.isSecond = false;
      } else if (tab.name === "second") {
        this.isSecond = true;
        this.isFirst = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
/deep/.el-form-item__label {
  text-align: left;
}

/deep/.el-input {
  width: 100%;
}

/deep/ .el-select {
  width: 100%;
}

/deep/.el-form-item {
  margin-bottom: 16px;
}

.icon {
  display: none;
  text-align: center;
}

/deep/.el-form-item__label {
  text-align: right;
}
.iconfont {
  display: none;
}

/deep/.el-form-item {
  width: 90%;
  margin-bottom: 22px;
}
.list-container {
  background-color: #fff;
  padding: 24px;
}
/deep/.el-tabs__content {
  overflow: visible;
}
</style>